import type { RuleHandler } from "../types";

const checkMaxStake: RuleHandler = (context, requirement) => {
  const maxStake = requirement.userDrivenAttributes?.maximumStake!;

  return context.selection.stake <= maxStake;
};

export { checkMaxStake };
